/* =========================
   HELPERS
========================= */
function clamp(n, min, max){ return Math.max(min, Math.min(max, n)); }

function getClosestSlideIndex(track, slideSelector = ".bm-slide"){
  const slides = Array.from(track.querySelectorAll(slideSelector));
  if(!slides.length) return 0;

  const left = track.scrollLeft;
  // encontrar el slide cuya offsetLeft esté más cerca al scrollLeft actual
  let best = 0;
  let bestDist = Infinity;
  slides.forEach((s, i) => {
    const dist = Math.abs(s.offsetLeft - left);
    if(dist < bestDist){ bestDist = dist; best = i; }
  });
  return best;
}

function scrollToIndex(track, index, slideSelector = ".bm-slide"){
  const slides = Array.from(track.querySelectorAll(slideSelector));
  if(!slides.length) return;

  const i = clamp(index, 0, slides.length - 1);
  track.scrollTo({ left: slides[i].offsetLeft, behavior: "smooth" });
}

function setDotsActive(dotsWrap, index){
  if(!dotsWrap) return;
  const dots = Array.from(dotsWrap.querySelectorAll(".bm-dot"));
  dots.forEach((d,i)=> d.classList.toggle("is-active", i === index));
}

/* =========================
   1) SOFTBOL MENU ARROWS
========================= */
(function softbolMenu(){
  const menu = document.querySelector(".sb-menu");
  if(!menu) return;

  const track = menu.querySelector(".sb-scroll");
  const btnL  = menu.querySelector(".sb-btn--left");
  const btnR  = menu.querySelector(".sb-btn--right");
  if(!track || !btnL || !btnR) return;

  const step = () => Math.round(track.clientWidth * 0.8);

  btnL.addEventListener("click", () => {
    track.scrollBy({ left: -step(), behavior: "smooth" });
  });

  btnR.addEventListener("click", () => {
    track.scrollBy({ left: step(), behavior: "smooth" });
  });
})();
/* =========================
   2) BM SLIDER (desktop + mobile) - FIXED
========================= */
(function bmSliders(){
  const sliders = document.querySelectorAll(".bm-slider");
  if(!sliders.length) return;

  sliders.forEach((slider) => {
    const track = slider.querySelector(".bm-track");
    if(!track) return;

    const prevBtn = slider.querySelector(".bm-prev");
    const nextBtn = slider.querySelector(".bm-next");
    const dotsWrap = slider.querySelector(".bm-dots");

    const slides = Array.from(track.querySelectorAll(".bm-slide"));
    if(!slides.length) return;

    // Forzar layout
    slides.forEach(s => {
      s.style.flex = "0 0 100%";
      s.style.scrollSnapAlign = "start";
    });

    let current = 0;

    function syncFromScroll(){
      current = getClosestSlideIndex(track, ".bm-slide");
      setDotsActive(dotsWrap, current);
    }

    // Flechas
    if(prevBtn){
      prevBtn.addEventListener("click", (e) => {
        e.preventDefault();
        current = getClosestSlideIndex(track, ".bm-slide");
        scrollToIndex(track, current - 1, ".bm-slide");
      });
    }

    if(nextBtn){
      nextBtn.addEventListener("click", (e) => {
        e.preventDefault();
        current = getClosestSlideIndex(track, ".bm-slide");
        scrollToIndex(track, current + 1, ".bm-slide");
      });
    }

    // Dots
    if(dotsWrap){
      const dots = Array.from(dotsWrap.querySelectorAll(".bm-dot"));
      dots.forEach((dot, i) => {
        dot.addEventListener("click", (e) => {
          e.preventDefault();
          scrollToIndex(track, i, ".bm-slide");
        });
      });
    }

    // Sync por scroll
    let raf = null;
    track.addEventListener("scroll", () => {
      if(raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(syncFromScroll);
    }, { passive: true });

    // Inicial
    syncFromScroll();

    // Resize
    window.addEventListener("resize", () => {
      scrollToIndex(track, current, ".bm-slide");
      syncFromScroll();
    });
    /* =========================
   AUTOPLAY
========================= */

let autoplay = setInterval(nextSlide, 5000);

function nextSlide(){
  current = getClosestSlideIndex(track, ".bm-slide");
  let next = current + 1;
  if(next >= slides.length) next = 0;
  scrollToIndex(track, next, ".bm-slide");
}

slider.addEventListener("mouseenter", () => clearInterval(autoplay));
slider.addEventListener("mouseleave", () => autoplay = setInterval(nextSlide, 5000));
  });
})();

/* =========================
   3) DROPS + TOP sliders arrows
========================= */
(function horizontalCards(){
  const setups = [
    { track: ".sb-drops__track", left: ".sb-drops__btn--left", right: ".sb-drops__btn--right" },
    { track: ".sb-top__track",   left: ".sb-top__btn--left",   right: ".sb-top__btn--right" }
  ];

  setups.forEach(cfg => {
    const track = document.querySelector(cfg.track);
    const left  = document.querySelector(cfg.left);
    const right = document.querySelector(cfg.right);
    if(!track || !left || !right) return;

    const step = () => Math.round(track.clientWidth * 0.85);

    left.addEventListener("click", () => {
      track.scrollBy({ left: -step(), behavior: "smooth" });
    });
    right.addEventListener("click", () => {
      track.scrollBy({ left: step(), behavior: "smooth" });
    });
  });
})();